import {mapState} from 'vuex';
import moment from 'moment';
import Vue from 'vue';
import {Tabs, Tab} from 'kpc/components/tabs';
import Table, {TableColumn} from 'kpc/components/table';
import {Pagination} from 'kpc/components/pagination';
import Button, {ButtonGroup} from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';
import Dialog from 'kpc/components/dialog';
import Input from 'kpc/components/input';
import Radio from 'kpc/components/radio';
import {Select, Option} from 'kpc/components/select';
import * as step1Const from '../../../store/create/step1/constants';
import * as commonConst from '../../../store/common/constants';
import Message from 'kpc/components/message';
import DateUtil from '../../../services/common/DateUtil';

import * as kecAPIs from '../../../services/kec/apis/kec'

import * as regionService from '../../../services/kec/region'
import * as diskService from '../../../services/kec/disk'
import * as _ from 'lodash'

export default ({
    name: 'snapCreateDia',
    components: {
        Table,
        TableColumn,
        Pagination,
        Button,
        ButtonGroup,
        Tooltip,
        Dialog,
        Input,
        Radio,
        Select,
        Option,
        Tabs,
        Tab,
        Message,
    },
    data() {
        return {
            snapCreateDiaShow: false,
            DateUtil,
            pages: {
                current: 1,
                total: 0,
                limit: 10,
                size: 'default' //指定组件的尺寸：large, default, small, mini
            },
            pagination: {
                enabled: false
            },
            checkedRows: [],
            isSnapCreateLocalDisk: false,
            dataDiskSnapTypeOrigin: [{
                title: this.$trans(`云盘快照`), //云盘快照,
                value: 'cloud_disk_snapshots',
                disabled: true
            }, {
                title: this.$trans(`本地盘快照`), //本地盘快照,
                value: 'local_disk_snapshots',
                disabled: true
            }],
            dataDiskSnapType: [],
            snapNameMap: {
                'active': this.$trans(`完成`), //完成
                'restoring': this.$trans(`回滚中`), //回滚中
                'saving': this.$trans(`创建中`), //  创建中
                'unknown': this.$trans(`未知错误`), //未知状态
                'error': this.$trans(`错误`), //错误
                'queued': this.$trans(`排队中`), //排队中
                'deleted': this.$trans(`主机已删除`) //主机已删除
            },
            dataDiskSnapId: 'cloud_disk_snapshots',
            snapEbsIdx: 0,
            snaptype: '',
            btnDisabled: true,
            btnLoading: false,
            diskObj: {},
            snapFilterList: [],
            azCode: '',
            kecType: '',
            dataDiskType: '',
            snapSearch: '',
            regionKey: '',

            snapList: [], // snapList: state => state.__pbc__.step1.snapList,
            snapTotal: 0, // snapTotal: state => state.__pbc__.step1.snapTotal,

            isEssdDataDisk: false,

            regionService,
            diskService,
            // tips:'',
            volumeMultiTypes: ['ESSD', 'ESSD_PL0', 'ESSD_PL1', 'ESSD_PL2', 'ESSD_PL3'],
        }
    },
    // props:{
    //     snapList: {
    //         required: true,
    //         type: Array,
    //         default: () => []
    //     },
    //     snapTotal: {
    //         required: true,
    //         type: Number,
    //         default: 0
    //     }
    // },
    watch: {
        pages(val, old) {
            // console.log(val.current != old.current, 'val.current != old.current')
            // console.log(val.limit != old.limit, 'val.limit != old.limit')
            val.current != old.current ? this.refresh() : undefined;
            val.limit != old.limit ? (this.pages.current = 1, this.refresh(true)) : undefined;
        },
        dataDiskSnapId(val) {
            if(val) {
                this.pages = {
                    current: 1,
                    total: 0,
                    limit: 10,
                };
                // console.log('dataDiskSnapId')
                this.refresh();
            }
        }
    },
    // computed: {
    //     ...mapState({
    //     //     // snapList: state => state.__pbc__.step1.snapList,
    //     //     // snapTotal: state => state.__pbc__.step1.snapTotal,
    //     //     pcommon: state => state.__pbc__.common,
    //     }),
    // },
    created() {

    },
    methods: {
        isDisable(data){
            if(this.snaptype === 'snapCreateEbsDisk') {
                const ebsDiskType = this.ebsDiskObjs[this.snapEbsIdx].value
                const volumeMultiTypes = this.volumeMultiTypes;
                if(data.disable){
                    return {
                        tips:data.trTitle,
                        disable: true
                    }
                }
                if(data.SnapshotType === 'LocalSnapShot'){
                    // 本地快照：不支持跨AZ 和 Region 不支持跨类型,pl1 pl2 pl3之间可以交叉开盘
                    if(!(data.AvailabilityZone === this.azCode &&
                        (data.VolumeType === ebsDiskType ||
                        (volumeMultiTypes.includes(ebsDiskType) && volumeMultiTypes.includes(data.VolumeType))))){
                        return {
                            tips:this.$trans(`极速可用快照只支持创建同类型数据盘`),
                            disable: true
                        }
                    }
                } 
                // if(data.SnapshotType === 'CommonSnapShot'){
                //     // 普通快照：支持跨AZ，不支持跨Region 
                //     //ebs3.0（ssd3.0 和 ehdd） 不支持ebs4.0(essd)
                //     //ebs4.0数据盘支持 ebs3.0（ssd3.0 和 ehdd）
                //     if(!volumeMultiTypes.includes(ebsDiskType) && volumeMultiTypes.includes(data.VolumeType)){
                //         return {
                //             tips:this.$trans(`ESSD4.0快照不支持创建其他类型数据盘`),
                //             disable: true
                //         }
                //     }
                // }
                if(data.Encrypted && (!this.hasKMSJurisdiction || data.VolumeType !== this.dataDiskType)){
                    let tips = ''
                    if(!this.hasKMSJurisdiction){
                        tips = this.$trans('当前用户暂无“KMS”产品计费方式权限，请联系对应工作人员开通')
                    } else {
                        tips = this.$trans('非当前数据盘类型的加密快照不可使用')
                    }
                    return {
                        tips,
                        disable: true
                    }
                }
            }
            return {
                tips:'',
                disable: false
            }
        },
        handle(params) {
            let promise = $.Deferred();

            if (params.type == 'snapCreateEbsDisk') {
                this.snaptype = params.type;
                this.regionKey = params.regionKey;
                this.snapEbsIdx = params.key;
                this.ebsDiskObjs = params.ebsDiskObjs;
                this.azCode = params.azCode;
                this.kecType = params.kecType;
                this.dataDiskType = params.dataDiskType;

                if (params.dataDiskType.includes('ESSD')) {
                    this.isEssdDataDisk = true;
                } else {
                    this.isEssdDataDisk = false;
                }

                // //标准IO优化型S4E 只支持云盘的本地盘为ESSD的快照
                // if (this.kecType == 498) {
                //     this.dataDiskSnapType = _.filter(this.dataDiskSnapTypeOrigin, (item) => {
                //         return item.value == 'cloud_disk_snapshots';
                //     });

                //ESSD云盘只支持云盘快照： 如：极速云盘型X6E 只支持云盘的本地快照 并且 ESSD的快照
                if (this.isEssdDataDisk) {
                    this.dataDiskSnapType = _.filter(this.dataDiskSnapTypeOrigin, (item) => {
                        return item.value == 'cloud_disk_snapshots';
                    });
                } else {
                    this.dataDiskSnapType = _.cloneDeep(this.dataDiskSnapTypeOrigin);
                }

                this.dataDiskSnapId = 'cloud_disk_snapshots';

                promise = $.when(this._snapCreateEbs())
            } else {
                this.snaptype = params.type;
                this.regionKey = params.regionKey;
                this.diskObj = params.diskObj;
                this.dataDiskSnapId = 'local_disk_snapshots';
                // console.log('123123')
                promise = $.when(this._snapCreateLocalDisk())
            }

            // promise.then(() => {
            //     this.snapCreateDiaShow = true
            // })
        },
        refresh() {
            this.loading = true;
            // this.$refs.mainTable.uncheckAll();
            // this.$store.commit(step1Const.getEbsSnap, []);
            // this.$store.commit(step1Const.kecGetSnap, []);
            this.btnSnapSearch();

        },
        btnSnapSearch() {
            this.snapFilterList = [];
            if (this.dataDiskSnapId == 'cloud_disk_snapshots') {
                this._snapCreateEbs();
            } else {
                // console.log('234234')
                this._snapCreateLocalDisk();
            }
        },
        close() {
            this.pages.current = 1;
            this.snapFilterList = [];
            this.snapSearch = '';
            this.snapCreateDiaShow = false;
        },
        ok() {
            if (this.checkedRows.length) {
                this.selectSnapEle(this.checkedRows[0]);
                this.snapSearch = '';
                this.btnDisabled = false;
                this.snapCreateDiaShow = false;
                this.snapFilterList = [];
            }
        },
        _snapCreateEbs() {
            // this.$store.dispatch(step1Const.getEbsSnap, {
            //     params: {
            //         Region: this.regionKey,
            //         AvailabilityZone: this.azCode,
            //         VolumeCategory: '', //获取系统盘和数据盘快照
            //         SnapshotName: this.snapSearch,
            //         PageNumber: this.pages.current,
            //         PageSize: this.pages.limit
            //     }
            // })
            let volumeMultiTypes = [];
            // if (this.isEssdDataDisk) {
            //     volumeMultiTypes = this.volumeMultiTypes;
            // }
            // else {
            //     volumeMultiTypes = []
            // }

            kecAPIs.DescribeSnapshots({
                params: {
                    Region: this.regionKey,
                },
                data: {
                    // AvailabilityZone: this.azCode,
                    VolumeCategory: '', //获取系统盘和数据盘快照
                    SnapshotName: this.snapSearch,
                    PageNumber: this.pages.current,
                    PageSize: this.pages.limit,
                    VolumeMultiTypes: volumeMultiTypes
                }
            }).then(res => {
                this.snapCreateDiaShow = true;
                if (!res || res.Snapshots.length === 0) {
                    Message.error('当前可用区下暂时没有可选的云盘快照！');
                    this.snapFilterList = [];
                    return;
                }
                let snapshots = res.Snapshots;
                _.forEach(snapshots, (item) => {
                    if (item.Size < this.ebsDiskObjs[this.snapEbsIdx].minValue || item.Size > this.ebsDiskObjs[this.snapEbsIdx].maxValue) {
                        // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
                        if (!this.isEssdDataDisk) {
                            item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.ebsDiskObjs[this.snapEbsIdx].minValue, this.ebsDiskObjs[this.snapEbsIdx].maxValue);
                            item.disable = true;
                        }

                    } else if (item.SnapshotStatus.toLowerCase() != 'available') {
                        // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                        // item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                        item.trTitle = this.$trans(`当前仅支持状态处于可用的快照`);
                        item.disable = true;
                    } else {
                        item.trTitle = ''
                    }
                });

                //如果是本地快照，不能修改数据盘类型，只保留选择的数据盘类型相同的快照
                // snapshots = _.filter(snapshots, (item) => {
                //     if (item.SnapshotType == 'LocalSnapShot') {
                //         return item.SnapshotId && item.VolumeType == this.dataDiskType;
                //     } else {
                //         return item.SnapshotId;
                //     }
                // });

                // //标准IO优化型S4E 只支持云盘的本地快照 并且 ESSD的快照
                // if (this.kecType == 498) {
                //     snapshots = _.filter(snapshots, (item) => {
                //         return item.VolumeType == 'ESSD' && item.SnapshotType == 'LocalSnapShot'
                //     });

                //ESSD云盘只支持云盘快照： 如：极速云盘型X6E 只支持云盘的本地快照 并且 ESSD的快照
                // if (this.isEssdDataDisk) {
                //     snapshots = _.filter(snapshots, (item) => {
                //         return /essd/.test(item.VolumeType.toLowerCase()) && item.SnapshotType == 'LocalSnapShot'
                //     });
                // } else {
                //     snapshots = _.filter(snapshots, (item) => {
                //         return !(/essd/.test(item.VolumeType.toLowerCase()))
                //     });
                // }

                this.snapFilterList = snapshots;
                this.pages.total = _.get(res.Page, 'totalCount', 0);
                // this.pages.total = snapshots.length;
                if (this.pages.total < this.pages.limit && this.pages.current > 1) {
                    this.pages.current = 1;
                    return this._snapCreateEbs();
                }
                this.isSnapCreateEbs = true;
            }).catch(e => {
                Message.error(e);
                this.isSnapCreateEbs = false;
            })
        },
        _snapCreateLocalDisk: _.debounce(function() {
            let _data = {
                Marker: (this.pages.current - 1) * this.pages.limit,
                MaxResults: this.pages.limit,
                Search: this.snapSearch,
            };

            // console.log(11111111111, '_snapCreateLocalDisk')

            // 本地盘数据盘支持本地盘数据盘快照，不支持本地系统盘快照， 不支持云盘数据盘快照， 不支持云盘系统盘快照
            // 云盘数据盘支持本地数据盘快照、本地系统盘快照、云盘数据盘快照、云盘系统盘快照
            if (this.snaptype == 'snapCreateEbsDisk') {
                // _data.LocalVolumeCategory = 'system'; //获取本地盘系统盘快照
            } else {
                _data.LocalVolumeCategory = 'data'; //获取本地盘数据盘快照
            }

            // this.$store.dispatch(step1Const.kecGetSnap, {
            //     params: {
            //         Region: this.regionKey
            //     },
            //     options: {
            //         isJSON: true,
            //         showLoading: true
            //     },
            //     data: _data
            // })
            kecAPIs.DescribeLocalVolumeSnapshots({
                params: {
                    Region: this.regionKey
                },
                data: _data
            }).then(res => {
                this.snapList = res.LocalVolumeSnapshotSet || [];
                this.snapTotal = res.LocalVolumeSnapshotCount;

                if (this.snapList.length == 0) {
                    Message.error('当前可用区下暂时没有可选的本地盘快照！');
                    return;
                }
                _.forEach(this.snapList, (item) => {
                    if (this.snaptype == 'snapCreateLocalDisk') {
                        if (item.MinDisk < this.diskObj.minValue || item.MinDisk > this.diskObj.maxValue) {
                            // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.diskObj.minValue + "~" + this.diskObj.maxValue + "GB的快照或更改CPU内存";
                            if (!this.isEssdDataDisk) {
                                item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.diskObj.minValue, this.diskObj.maxValue);
                                item.disable = true;
                            }
                        } else if (item.State.toUpperCase() != 'ACTIVE' && item.State.toUpperCase() != 'RESTORING') {
                            // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                            item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                            item.disable = true;
                        } else {
                            item.trTitle = ''
                        }
                    } else {
                        if (item.MinDisk < this.ebsDiskObjs[this.snapEbsIdx].minValue || item.MinDisk > this.ebsDiskObjs[this.snapEbsIdx].maxValue) {
                            // item.trTitle = "提示：快照大小超出数据盘容量范围，请选择" + this.ebsDiskObjs[this.snapEbsIdx].minValue + "~" + this.ebsDiskObjs[this.snapEbsIdx].maxValue + "GB的快照或更改CPU内存";
                            if (!this.isEssdDataDisk) {
                                item.trTitle = this.$trans(`提示：快照大小超出数据盘容量范围，请选择{0}~{1}GB的快照或更改CPU内存`, this.ebsDiskObjs[this.snapEbsIdx].minValue, this.ebsDiskObjs[this.snapEbsIdx].maxValue);
                                item.disable = true;
                            }
                        } else if (item.State.toUpperCase() != 'ACTIVE' && item.State.toUpperCase() != 'RESTORING') {
                            // item.trTitle = "提示：当前不支持处于" + this.common.nameMap(data.row.State) + "的快照";
                            item.trTitle = this.$trans(`提示：当前不支持处于{0}的快照`, this.snapNameMap[item.State.toLowerCase()]);
                            item.disable = true;
                        } else {
                            item.trTitle = ''
                        }
                    }
                });
                this.snapFilterList = _.cloneDeep(this.snapList);
                this.pages.total = this.snapTotal;
                this.isSnapCreateLocalDisk = true;
                this.snapCreateDiaShow = true;
            }).catch(e => {
                // console.log(e, 111)
                Message.error(e);
                this.isSnapCreateLocalDisk = false;
            })
        }, 100),
        selectSnapEle(item) {
            item.snapEbsIdx = this.snapEbsIdx;
            item.snaptype = this.snaptype;
            this.$emit('setSnapEle', item);
            this.snapCreateDiaShow = false;
        },
        _checkHandler(ele) {
            this.checkedRows = ele.getCheckedData();
            if (this.checkedRows.length) {
                this.btnDisabled = false;
            }
        },
        _changePages(type, c, v) {
            this.pages = {
                ...this.pages,
                [type]: v
            };
        }

    },

});
